import { useEffect, useState } from 'react';

import { trlDetailsServices } from '»components/molecules/TrlDetailsIntrument/trlDetails.services';

export function useDocuments(noteId) {
  const [documents, setDocuments] = useState([]);

  const callDocs = async () => {
    const response = await trlDetailsServices.FilesService({ noteId });
    setDocuments(response);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (noteId) callDocs();
  }, []);

  return {
    documents,
  };
}
